import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WidgetData } from 'src/app/api/bizzmine/dashboard/dashboard-api.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetApiService {

  constructor(private http: HttpClient) {
  }

  public getWidgetByWorkspaceItemId(workspaceItemId: number): Observable<WidgetData> {
    return this.http.get<WidgetData>(`api/widget/workspaceitem/${workspaceItemId}`);
  }

  public getWidgetByWorkspaceItemIdResponse(workspaceItemId: number): Observable<HttpResponse<WidgetData>> {
    return this.http.get<WidgetData>(`api/widget/workspaceitem/${workspaceItemId}`, { observe: 'response' });
  }
}
